import type { GetElementClassNameFn } from "@b2bportal/core-themes";
import type { HotelRoomRateMeta } from "@b2bportal/core-types";
import { RadioGroup } from "@tenant/ui";
import { HotelRoomRates } from "../HotelRoomRate";

export const MealPlansToShow = ({
  rates,
  cn,
  selectedRate,
  setSelectedRate,
}: {
  rates: HotelRoomRateMeta[];
  cn: GetElementClassNameFn;
  selectedRate: HotelRoomRateMeta;
  setSelectedRate: (rate: HotelRoomRateMeta) => void;
}) => {
  const radioOptions = rates.map((rate) => {
    return {
      id: rate.key,
      // Key is needed to differentiate between the cancellation rates and meal rates
      key: `meal-${rate.key}`,
      value: rate.key,
      disabled: rate.product.rateId === undefined,
      label: (
        <HotelRoomRates
          key={rate.key}
          className={cn("room-rate", {
            selected: selectedRate.product.rateId?.value === rate.key,
          })}
          product={rate.product}
          priceDifference={rate.priceDifference}
          mealPlanRate
          disabled={rate.product.rateId === undefined}
        />
      ),
    };
  });
  return (
    <RadioGroup
      className={cn("rate-radio-group")}
      options={radioOptions}
      selectedOption={selectedRate.key}
      onSelectValue={(id) => {
        const rate = rates.find((r) => r.key === id);
        if (rate != null) setSelectedRate(rate);
      }}
    />
  );
};
